<template>
  <div>
    <van-list v-model="isLoading" :finished="isFinished" :finished-text="!list || list.length > 0 ? '没有更多了' : ''"
      @load="fetchData" class="users-list">

      <dl class="users-list" v-if="!isInit && (list && list.length>0)">
        <dt class="users-title">
          <span class="title">我关注的人</span>
        </dt>
        <dd class="users-item" v-for="(item, index) in list" :key="index" @click="jump(item)">
          <div class="head-box">
            <div class="img-box">
              <img v-lazy="item.headPicUrl" alt="" class="img" />
            </div>
          </div>
          <div class="infomation">
            <p class="name-box"><span class="name">{{item.nickName}}</span></p>
            <p class="sentence">
              现居{{`${parseInt(item.cityId) === 900000 ? (item.country + ' ' + item.state) : areaData['city_list'][item.cityId]}`}}
              {{item.age}}岁 {{item.high}}cm {{educationMap[item.education]}}
              {{item.ifStudent ? '在读' : item.job}}</p>
          </div>
        </dd>
      </dl>

      <dl class="users-list" v-if="!isInit && (!list || list.length === 0)">
        <dt class="users-title">
        </dt>
        <dd>
          <p class="no-message-tips">您还未关注任何人</p>
          <img src="~@/assets/img/no-search-result.png" alt="" class="no-message-img" />
        </dd>
      </dl>

    </van-list>

    <banModal v-model="showModal" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import banModal from './component/banModal'

export default {
  name: 'Follow',
  components: {
    banModal
  },
  data () {
    return {
      isLoading: false,
      isFinished: false,
      currentPage: 1,
      pageSize: 20,
      list: [],
      isInit: true,
      showModal: false
    }
  },
  computed: {
    ...mapState({
      educationMap: 'educationMap',
      areaData: 'areaData'
    }),
    ...mapGetters({
      userId: 'userId'
    })
  },
  methods: {
    fetchData () {
      this.$root.openLoading()
      this.isLoading = true
      this.$http('/api/member/action/list', {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        actionType: 10
      }, 'get').then(res => {
        this.isLoading = false
        if (res.code === '0000' && res.data) {
          const data = res.data
          if (this.currentPage === 1) {
            this.list = data.data
          } else {
            this.list = [...this.list, ...data.data]
          }
          try {
            if (this.pageSize > data.data.length || !this.userId) {
              this.isFinished = true
            }
          } catch (err) {
            this.isFinished = true
          }
          this.currentPage++
        } else {
          this.isFinished = true
          this.$toast(res.msg)
        }
      }, err => {
        this.isFinished = true
        this.isLoading = false
        this.$toast(err)
      }).finally(() => {
        this.isInit = false
        this.$root.closeLoading()
      })
    },
    jump (item) {
      if (item.singleStatus === 6 || item.singleStatus === 7) {
        this.showModal = true
      } else {
        this.$router.push({
          path: `/info-${item.mid}.html`
        })
      }
    }
  }
}
</script>
